export function Separator() {
  return (
    <div
      className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
      aria-hidden="true"
    />
  )
}
